import type { IErrorOtp } from '@/shared/common/types/otpError.type';

export const ErrorsOtp: IErrorOtp = {
  FORBIDDEN: 'El código ingresado no es válido. Por favor, verifica e inténtalo de nuevo.',
  PIN_REQUIRED: 'Se requiere pin de validación',
  OTP_FAILED_ATTEMPT_ONE: 'Otp inválido, intento fallido número 1',
  OTP_FAILED_ATTEMPT_TWO: 'Otp inválido, intento fallido número 2',
  OTP_FAILED_ATTEMPT_THREE: 'Otp inválido, intento fallido número 3',
  OTP_FAILED_ATTEMPT_FOUR: 'Otp inválido, intento fallido número 4',
  OTP_FAILED_ATTEMPT_FIVE: 'Otp inválido, intento fallido número 5',
  OTP_FAILED_ATTEMPT_SIX: 'Otp inválido, intento fallido número 6',
  ATTEMPT_LIMIT_EXCEEDED: 'Límite de intentos superado. Debes generar un nuevo Otp.',
  OTP_VALIDATION_FAILED: 'Otp inválido. Vuelve a intentarlo',
  OTP_REQUIRED: 'Se requiere código de validación',
  NOT_FOUND: 'No se encontró el OTP. Vuelve a generar uno',
  HELPER_COMPONENT: 'Token de acceso expirado',
  UNAUTHORIZED: 'Tu cuenta necesita atención, contacta con un asesor',
  TRANSACTION_CUSTOMER_UNDER_COMPLIANCE_REVIEW_2:
    'Tu cuenta esta en revisión, comunícate con soporte (UCR2)',
  TRANSACTION_EXPIRED_QUOTE: 'La cotización ha expirado. Vuelve a generar uno nuevo',
  CUSTOMER_ACCOUNT_NEED_ATTENTION:
    'Tu cuenta necesita atención, contacta con un asesor',
  CUSTOMER_NOT_ENABLED: 'Tu cuenta no está habilitada para realizar esta operación',
  TRANSACTION_LIMIT_EXCEEDED:
    'El monto de la operación supera el límite permitido para tu cuenta',
  TRANSACTION_GENERIC_ERROR: 'Ocurrió un error inesperado, inténtalo más tarde',
  ERROR_EXCHANGE_SAME_CURRENCY:
    'No puedes realizar una operación con la misma moneda de origen y destino',
  GENERIC_ERROR: 'Ocurrió un error inesperado, inténtalo más tarde',
  DEFAULT: 'Error al validar el código. Vuelve a intentarlo más tarde',
  CUSTOMER_NOT_FOUND: 'No se ha encontrado el usuario',
  TOO_MANY_REQUESTS: 'Has realizado muchas solicitudes de código, espera 5 minutos para volver a ingresar',
  RECAPTCHA_SCORE_TOO_LOW:
    'Completa la verificación de seguridad para recibir tu código',
  INTERNAL_SERVER_ERROR: 'Ocurrió un error inesperado, inténtalo más tarde',
  '': '',
  UNSUPPORTED_TRANSFER_OPERATION: 'No es posible enviar dinero desde una billetera regulada a una billetera no regulada',
} as const;
